import { createContext, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useStore from "store/store";
import { CURRENCY_TEXT } from "variables/constants";

const AppContext = createContext();

export function PricingWrapper({ children }) {
    const {t} = useTranslation();
    const store = useStore();

    const floatPrice = (price) => {
        if(typeof price === "string") price = parseFloat(price);
        return price;
    }

    const addAll = (prices) => {
        let total = 0;
        prices.forEach(price => {
            total+=parseFloat(price)
        });
        return total;
    }

    const calculate = (price, quantity, discount, currency) => {
        price = floatPrice(price);
        return calculateDouble(price, quantity, discount) + " " + t(CURRENCY_TEXT[currency || store.currency]);
    }

    const calculateDouble = (price, quantity, discount) => {
        price = floatPrice(price);
        if(!quantity) quantity = 1;
        let total = (price * quantity);
        if (total <= 0) total = price;
        if (discount) {
          total = total - ((discount / 100) * total);
        }
        return total ? total.toFixed(2) : total;
    }

    const format = (price, currency) => {
        price = floatPrice(price);
        return formatDouble(price) + " " + t(CURRENCY_TEXT[currency || store.currency])
    }

    const formatDouble = (price) => {
        price = floatPrice(price);
        return price.toFixed(2);
    }


    let sharedState = {
        format,
        formatDouble,
        calculate,
        calculateDouble,
        addAll
    };

    return (
        <AppContext.Provider value={sharedState}>{children}</AppContext.Provider>
    );
}

//import this function wherever you want to use the store above
export default function usePricing() {
    return useContext(AppContext);
}
